import React from "react";

import { Trans } from "react-i18next";

const MainLoadingButton = ({
    buttonText,
    isRequesting,
    isDisabled,
    onClick = () => {},
    iconClassName = "",
    className = "",
    buttonStyle = "default-orange-outline-btn",
}) => {
    return (
        <>
            <button
                className={`${buttonStyle} ${className} ${
                    isRequesting || isDisabled ? "disabled" : ""
                }`}
                disabled={isRequesting || isDisabled}
                onClick={onClick}
            >
                {isRequesting ? (
                    <>
                        <span className="animate-spin mr-3 inline-flex">
                            <i className="fas fa-sync"></i>
                        </span>
                        <Trans i18nKey="requesting">Requesting...</Trans>
                    </>
                ) : (
                    <>
                        {iconClassName && (
                            <i className={`${iconClassName} mr-1`}></i>
                        )}
                        {buttonText}
                    </>
                )}
            </button>
        </>
    );
};

export default MainLoadingButton;
